import * as mbtiPersonalityTest from './MBTI_personality_test.json';
import * as theBigFiveAssessment from './the_big_five_assessment.json';

export default {
  ...mbtiPersonalityTest,
  ...theBigFiveAssessment,
};
